export enum ReportType {
    PivotTableReport = '-1',
    StandartReport = '1',
}